<template lang="pug">
#media
  .page-controls
    b-field(grouped)
      b-field(expanded)
        media-search(
          :indexes="indexes"
          placeholder="Filter media..."
          @select="addTag"
        )
      //- b-field
      //-   b-datepicker(
      //-     icon="calendar-blank"
      //-     placeholder="Dates"
      //-     position="is-bottom-left"
      //-     :value="filters.dates"
      //-     @input="setFilter($event, 'dates')"
      //-     range
      //-   )
      //-     a.button.is-danger(@click="resetDates") Reset
      b-field(v-if="mediaTab === 'channels'")
        .control
          a.button(@click="triggerPodcastSettings")
            b-icon(icon="itunes")
            span iTunes
      b-field
        .control
          button.button.is-success(
            @click="triggerNew"
            icon="plus"
          )
            b-icon(icon="plus")
            span New {{ btnLabel }}
    filter-tags(mode="media")
  b-tabs.page-tabs(
    :value="tabIndex"
    :animated="false"
    @change="changeTab"
    position="is-centered"
  )
    b-tab-item(label="Episodes")
      episodes-tab
    b-tab-item(label="Channels / Feeds")
      channels-tab
    b-tab-item(label="Collections")
      collections-tab
    b-tab-item(label="Speakers")
      speakers-tab
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ChannelForm from '@/components/form/ChannelForm';
import ChannelsTab from '@/components/ChannelsTab';
import CollectionForm from '@/components/form/CollectionForm';
import CollectionsTab from '@/components/CollectionsTab';
import EpisodeForm from '@/components/form/EpisodeForm';
import EpisodesTab from '@/components/EpisodesTab';
import FilterTags from '@/components/FilterTags';
import MediaSearch from '@/components/MediaSearch';
import SpeakerForm from '@/components/form/SpeakerForm';
import SpeakersTab from '@/components/SpeakersTab';
import Spinner from '@/components/Spinner';
import PodcastSettingsForm from '@/components/form/PodcastSettingsForm';
import PubTag from '@/components/PubTag';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'media',
  components: {
    ChannelForm,
    ChannelsTab,
    CollectionForm,
    CollectionsTab,
    EpisodeForm,
    EpisodesTab,
    FilterTags,
    MediaSearch,
    SpeakerForm,
    SpeakersTab,
    Spinner,
    PubTag,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      editing: getters.GET_EPISODE,
      filters: getters.GET_MEDIA_FILTERS,
      mediaTab: getters.GET_MEDIA_TAB,
      refresh: getters.GET_MEDIA_REFRESH,
    }),
    btnLabel() {
      const singluar = this.mediaTab.slice(0, this.mediaTab.length - 1);
      return singluar.charAt(0).toUpperCase() + singluar.slice(1);
    },
    tabIndex() {
      return _.indexOf(this.tabs, this.mediaTab);
    },
  },
  created() {
    if (this.tab) {
      this.$store.commit(mutations.SET_MEDIA_TAB, this.tab);
    }
  },
  data() {
    return {
      indexes: [
        'doxa_speakers',
        'doxa_channels',
        'doxa_episode_collections',
        'doxa_episodes',
      ],
      settings: {
        loading: false,
      },
      tabs: [
        'episodes',
        'channels',
        'collections',
        'speakers',
      ],
    };
  },
  methods: {
    addTag(tag) {
      this.$store.commit(mutations.TOGGLE_MEDIA_TAG, tag);
      this.$store.commit(mutations.SET_MEDIA_REFRESH, true);
    },
    changeTab(index) {
      const tab = this.tabs[index];
      this.$store.commit(mutations.SET_MEDIA_TAB, tab);
      this.$router.push({ name: 'media', query: { tab } });
    },
    resetDates() {
      this.$store.commit(mutations.SET_MEDIA_FILTER_DEFAULT_DATES);
      this.$store.commit(mutations.SET_MEDIA_REFRESH, true);
    },
    setFilter(val, key) {
      this.$store.commit(mutations.SET_MEDIA_FILTER_FIELD, {
        key,
        val,
      });
      this.$store.commit(mutations.SET_MEDIA_REFRESH, true);
    },
    triggerNew() {
      const opts = {
        parent: this,
        hasModalCard: true,
      };
      switch (this.mediaTab) {
        case 'episodes':
          this.$store.commit(mutations.UNSET_EPISODE);
          opts.component = EpisodeForm;
          break;
        case 'channels':
          this.$store.commit(mutations.UNSET_CHANNEL);
          opts.component = ChannelForm;
          break;
        case 'collections':
          this.$store.commit(mutations.UNSET_COLLECTION);
          opts.component = CollectionForm;
          break;
        case 'speakers':
          this.$store.commit(mutations.UNSET_SPEAKER);
          opts.component = SpeakerForm;
          break;
        default:
      }
      this.$buefy.modal.open(opts);
    },
    triggerPodcastSettings() {
      this.$buefy.modal.open({
        parent: this,
        component: PodcastSettingsForm,
        hasModalCard: true,
      });
    },
  },
  props: {
    tab: {
      type: String,
      default: 'episodes',
    },
    page: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss">
#media {
  table {
    tr {
      cursor: pointer;
    }
  }
}
.edit-dropdown {
  .dropdown-content {
    padding-top: 0;
    .dropdown-item.is-paddingless + hr {
      margin-top: 0;
    }
  }
}
.episode-meta-icons {
  position: relative;
  top: 3px;
  .icon + .icon {
    margin-left: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Media.vue